import { render, staticRenderFns } from "./TestSidebar.vue?vue&type=template&id=3d11e7f0&scoped=true&"
import script from "./TestSidebar.vue?vue&type=script&lang=js&"
export * from "./TestSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11e7f0",
  null
  
)

export default component.exports